module.exports = __webpack_public_path__ + "static/media/instant-icon.73cd734a.svg";